import { z } from 'zod';

import { Voltage } from './Voltage';

export const MaximumPowerPointVoltage = {
    validator: Voltage.validators.value,
    units: Voltage.units,
};

export type MaximumPowerPointVoltage = z.infer<typeof MaximumPowerPointVoltage.validator>;
